import React from 'react';
import {
  Container,
  Typography,
  Box,
  Paper,
  Divider,
  Button
} from '@mui/material';
import {
  Security,
  Lock,
  Person,
  ContactSupport,
  ArrowBack
} from '@mui/icons-material';
import { useNavigate } from 'react-router-dom';

const PrivacyPolicy = () => {
  const navigate = useNavigate();

  return (
    <Container maxWidth="md" sx={{ py: 4 }}>
      <Button
        startIcon={<ArrowBack />}
        onClick={() => navigate('/')}
        sx={{ mb: 3 }}
      >
        Back to Portfolio
      </Button>
      
      <Paper elevation={3} sx={{ p: 4 }}>
        <Typography variant="h4" component="h1" gutterBottom>
          Privacy Policy
        </Typography>
        
        <Typography variant="body2" color="text.secondary" gutterBottom>
          Effective Date: December 2024
        </Typography>
        <Typography variant="body2" color="text.secondary" gutterBottom>
          App Name: Secure File Encryption
        </Typography>
        <Typography variant="body2" color="text.secondary" gutterBottom>
          Platform: iOS
        </Typography>
        <Typography variant="body2" color="text.secondary" gutterBottom>
          Developer: Michael R. Ellis
        </Typography>

        <Divider sx={{ my: 3 }} />

        <Box sx={{ mb: 4 }}>
          <Typography variant="h5" component="h2" gutterBottom sx={{ display: 'flex', alignItems: 'center' }}>
            <Security sx={{ mr: 1 }} />
            Overview
          </Typography>
          <Typography variant="body1" paragraph>
            This app is designed for secure file encryption and storage. We prioritize privacy and security by keeping all user data entirely local to the device. Your information is never collected, shared, or transmitted—period.
          </Typography>
        </Box>

        <Box sx={{ mb: 4 }}>
          <Typography variant="h5" component="h2" gutterBottom sx={{ display: 'flex', alignItems: 'center' }}>
            <Lock sx={{ mr: 1 }} />
            Data Collection & Usage
          </Typography>
          <Typography variant="body1" paragraph>
            We do not collect, store, or transmit any personal or usage data. The app operates fully offline with no internet access and no connections to external servers or third-party services. No analytics, crash reporting, or advertising technologies are used.
          </Typography>
        </Box>

        <Box sx={{ mb: 4 }}>
          <Typography variant="h5" component="h2" gutterBottom sx={{ display: 'flex', alignItems: 'center' }}>
            <Security sx={{ mr: 1 }} />
            Encryption & Security
          </Typography>
          <Typography variant="body1" paragraph>
            All encrypted files are stored locally using AES-256 encryption. Encryption and decryption occur exclusively on-device. Secure Enclave is used to safeguard encryption keys. Biometric authentication (e.g., Face ID or Touch ID) can be enabled for secure access. No encryption keys or user data ever leave the device.
          </Typography>
        </Box>

        <Box sx={{ mb: 4 }}>
          <Typography variant="h5" component="h2" gutterBottom sx={{ display: 'flex', alignItems: 'center' }}>
            <Person sx={{ mr: 1 }} />
            User Accounts & Personal Information
          </Typography>
          <Typography variant="body1" paragraph>
            No account registration or login is required. The app does not collect any personal information. Users can fully delete all data by uninstalling the app.
          </Typography>
        </Box>

        <Box sx={{ mb: 4 }}>
          <Typography variant="h5" component="h2" gutterBottom>
            Children's Privacy
          </Typography>
          <Typography variant="body1" paragraph>
            The app does not include parental controls and is not specifically targeted toward children under the age of 13.
          </Typography>
        </Box>

        <Box sx={{ mb: 4 }}>
          <Typography variant="h5" component="h2" gutterBottom>
            Your Rights
          </Typography>
          <Typography variant="body1" paragraph>
            As no data is collected, there is no data to access, modify, or delete beyond what is stored locally. Uninstalling the app permanently removes all app data from your device.
          </Typography>
        </Box>

        <Box sx={{ mb: 4 }}>
          <Typography variant="h5" component="h2" gutterBottom sx={{ display: 'flex', alignItems: 'center' }}>
            <ContactSupport sx={{ mr: 1 }} />
            Contact
          </Typography>
          <Typography variant="body1" paragraph>
            For any inquiries related to privacy or app functionality, please contact us at:{' '}
            <a href="mailto:michael94ellis@gmail.com" style={{ color: '#1976d2', textDecoration: 'none' }}>
              michael94ellis@gmail.com
            </a>
          </Typography>
        </Box>
      </Paper>
    </Container>
  );
};

export default PrivacyPolicy; 